import { post } from "@rails/request.js";
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle-button"
export default class extends Controller {
  static values = {
    url: String,
    attribute: String,
  };

  async toggle(event) {
    let isChecked = event.target.checked;
    let attribute = event.target.dataset.toggleButtonAttributeValue;

    let confirmed = this.confirmToggle(attribute, isChecked);

    if (confirmed) {
      let valueToSend =
        attribute === "status" ? (isChecked ? 1 : 0) : isChecked;

      let response = await post(this.urlValue, {
        body: JSON.stringify({ camera: { [attribute]: valueToSend } }),
        contentType: "application/json",
      });

      if (!response.ok) this.reset_button(event.target);
    } else {
      this.reset_button(event.target);
    }
  }

  confirmToggle(attribute, isChecked) {
    let message;

    if (attribute === "status") {
      message = `This camera will also be ${
        isChecked ? "added to" : "removed from"
      } the dashboard. Still do you want to ${
        isChecked ? "activate" : "deactivate"
      } the camera?`;
    } else {
      message = `Do you want to ${isChecked ? "enable" : "disable"} feature?`;
    }

    return confirm(message);
  }

  reset_button(element) {
    element.checked = !element.checked;
  }
}
